export const Logout = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M0 4.447C0 1.996 2.03024 0 4.52453 0H9.48564C11.9748 0 14 1.99 14 4.437V15.553C14 18.005 11.9698 20 9.47445 20H4.51537C2.02515 20 0 18.01 0 15.563V14.623V4.447Z"
        fill="#CC5F5F"
      />
      <path
        d="M19.779 9.4548L16.9332 6.5458C16.6391 6.2458 16.1657 6.2458 15.8726 6.5478C15.5804 6.8498 15.5814 7.3368 15.8745 7.6368L17.4338 9.2298H15.9388H7.5485C7.13459 9.2298 6.79858 9.5748 6.79858 9.9998C6.79858 10.4258 7.13459 10.7698 7.5485 10.7698H17.4338L15.8745 12.3628C15.5814 12.6628 15.5804 13.1498 15.8726 13.4518C16.0196 13.6028 16.2115 13.6788 16.4043 13.6788C16.5952 13.6788 16.7871 13.6028 16.9332 13.4538L19.779 10.5458C19.9202 10.4008 20 10.2048 20 9.9998C20 9.7958 19.9202 9.5998 19.779 9.4548Z"
        fill="#CC5F5F"
      />
    </svg>
  );
};
